






























import {Component, Vue, Watch} from 'vue-property-decorator';

@Component({
    components: {
    }
})
export default class JdpAdminUsers extends Vue {

}
